import React, { useState, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
// import Home from "./pages/Home";
// import PageEditor from "./pages/PageEditor";
// import FlowEditor from "./pages/FlowEditor";
// import ResourceEditor from "./pages/ResourceEditor";
//import Header from './components/Header';
import './assets/scss/custom.scss';
import './App.scss';
import './assets/scss/icons.css';
import 'react-tooltip/dist/react-tooltip.css';
import keycloak from 'Keycloak';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setCommonDataModelData } from 'store/slices/commonDataSlice';
import { setWorkspaceData } from 'store/slices/workspaceSlice';
import useAxiosFetch from 'hooks/useAxiosFetch';
import jwt_decode from 'jwt-decode';
import { apiBackendBaseUrl, keyClockEndPoint, testingUrl, testUrl } from 'utils/envsetup';
import { pageview, pageEventName } from 'utils/GtmUtil';
import axiosInstance from 'utils/axiosInstance';
import { PopoverProvider } from 'utils/PopoverContext';
import { clearFlowEditor } from 'store/slices/flowEditorSlice';
import { resetWorkspace } from 'store/slices/workspaceSlice';
import { resetPageEditor } from 'store/slices/pageEditorSlice';
import { resetPageEditorCanvas } from 'store/slices/pageEditorCanvasSlice';
import { resetCommonData } from 'store/slices/commonDataSlice';
import { resetResourceEditor } from 'store/slices/resourceEditorSlice';
import NewUpdatePopup from './components/NewUpdatePopup';
import { useSelector } from 'react-redux';
import { updateZoomPercentage } from 'store/slices/pageEditorCanvasSlice';
// import axios from 'axios';
import axios from 'utils/axiosInstance';
import store from 'store';
import { requestHeaders } from 'utils/HttpClient';
import useAxiosFunction from 'hooks/useAxiosFunction';
import Signup from 'pages/Signup';
//import TagManager from 'react-gtm-module'
import UserProfile from './pages/Signup/userProfile';
import { useNavigate } from 'react-router-dom/dist';
import { resetPageEditorModelData } from 'store/slices/pageEditorModelDataSlice';
import { resetAuthToken, setAuthToken } from 'store/slices/authTokenSlice';
import PackageListing from 'components/PageEditor/Package/PackageListing';
import PackageMain from 'components/PageEditor/Package/PackageMain';
import GenerateApps from 'components/PageEditor/GenerateApps';
import { hasAdminRoleMoveApps, hasAdminRoleMultipleDeployment, hasAdminUiAddChargeRole, hasAdminUiApplyDiscountRole, hasAdminUiRole, hasAdminUiSyncPaymentRole, hasAdminUiViewTimelineRole, hasAdminUserCreateRole, hasAdminUserDeleteRole, hasSalesRole, hasAdminUiAdminRole, hasAdminUiPaymentLinkGenerationRole,hasAdminUiDomainWriteManagementRole,hasAdminUiDomainReadManagementRole } from 'utils/CommonFunction';
import SearchDomain from 'components/AdminDashboard/LayoutRight/Domain Management/SearchDomain';
import ReferralCode from 'components/AdminDashboard/LayoutRight/UserManagement/ReferralCode';
//import useEventTrace from 'utils/CommonRequestConfig';
const FlowExecutionTab = React.lazy(()=> import('components/FlowEditor/ViewFlowExecution/FlowExecutionTab'));
const AccountTabComponent = React.lazy(()=> import('./components/Account/AccountTab'));
const PaymentLink = React.lazy(()=> import('components/Account/Payment/PaymentLink'));
const GenerateInvoice = React.lazy(()=> import('components/Account/Payment/GenerateInvoice'));
const Invoice = React.lazy(()=> import('components/Account/Payment/Invoice'));
const CancelSubscription =  React.lazy(()=> import('components/Account/Subscriptions/CancelSubscription'));
const Callback = React.lazy(() => import('./pages/ResourceEditor/callback'));
const Home = React.lazy(() => import('./pages/Home'));
const LoggerModalParent = lazy(() => import('containers/logger/LoggerModalParent'));
const  MakePayment=  React.lazy(() => import('./pages/Payment/MakePayment'));
const WorkSpace = React.lazy(() => import('./pages/WorkSpace'));
const PageEditor = React.lazy(() => import('./pages/PageEditor'));
const FlowEditor = React.lazy(() => import('./pages/FlowEditor'));
const ResourceEditor = React.lazy(() => import('./pages/ResourceEditor'));
const PageTemplates = React.lazy(() => import('./components/PageEditor/PageTemplates'));
const AppTemplates = React.lazy(() => import('./components/PageEditor/AppTemplates'));
const PreviwDetail = React.lazy(() =>
  import('./components/PageEditor/PageTemplates/PreviewDetail'),
);
const Header = React.lazy(() => import('./components/Header/HomeHeader'));
const LayoutWithHeader = React.lazy(() => import('./components/LayoutWithHeader'));
const ResponsiveViewPageEditor = React.lazy(() => import('./pages/ResponsiveViewPageEditor'));
const PageTemplateListing = React.lazy(() => import('./components/PageEditor/PageTemplateListing'));
const PageTemplate = React.lazy(() =>
  import('./components/PageEditor/PageTemplateListing/PageTemplate'),
);
const SectionTemplate = React.lazy(() =>
  import('./components/PageEditor/PageTemplateListing/SectionTemplate'),
);
const AppTemplate = React.lazy(() =>
  import('./components/PageEditor/PageTemplateListing/AppTemplate'),
);
const HelpDoc = React.lazy(() => import('./pages/HelpDoc'));
localStorage.setItem('app-refresh-trigger', 'false');
const GenAiTemplate = React.lazy(()=> import( 'components/GenAiTemplate'));
const GenerateApp = React.lazy(()=> import( 'components/GenAiTemplate/GenerateApp'));
const WebsiteGen = React.lazy(()=> import('components/GenAiTemplate/WebsiteGen'));
const AdminDashboard = React.lazy(() => import('./pages/AdminDashboard'));
const SignupNewUser = React.lazy(()=>import('components/AdminDashboard/LayoutRight/UserManagement/SignupNewUser'))
const DeleteUser = React.lazy(()=>import('components/AdminDashboard/LayoutRight/UserManagement/DeleteUser'))
const Search = React.lazy(()=>import('components/AdminDashboard/LayoutRight/UserManagement/Search'))
const MultipleDeployment = React.lazy(()=>import('components/AdminDashboard/LayoutRight/RoleManagement/MultipleDeployment'))
const MoveApps = React.lazy(()=>import('components/AdminDashboard/LayoutRight/RoleManagement/MoveApps'))
// const ViewTimeline = React.lazy(()=>import('components/AdminDashboard/LayoutRight/SubscriptionPayments/ViewTimeline'))
const AddCharge = React.lazy(()=>import('components/AdminDashboard/LayoutRight/SubscriptionPayments/AddCharge'))
const SyncPayment = React.lazy(()=>import('components/AdminDashboard/LayoutRight/SubscriptionPayments/SyncPayment'))
const ApplyDiscount = React.lazy(()=>import('components/AdminDashboard/LayoutRight/SubscriptionPayments/ApplyDiscount'))
const AdminUiRoles = React.lazy(()=>import('components/AdminDashboard/LayoutRight/RoleManagement/AdminUiRoles'))
const Paymentlink = React.lazy(()=> import('components/AdminDashboard/LayoutRight/SubscriptionPayments/PaymentLink'));
// const tagManagerArgs = {
//   gtmId: 'GTM-T84W4GB3'
// }

// TagManager.initialize(tagManagerArgs)

function App(props) {
  /**
   * createBrowserRouter which create the router instance
   * have to declare all the routes in the object
   */
  // const router = createBrowserRouter([
  //   {
  //     path: "/",
  //     element: <Home />,
  //     children: [
  //       {
  //         path: "/"
  //       }
  //     ]
  //   },
  //   {
  //     path: "/page-editor",
  //     element:<PageEditor />,
  //   },
  //   {
  //     path: "/flow-editor",
  //     element:<FlowEditor />,
  //   },
  //   {
  //     path: "/resource-editor",
  //     element:<ResourceEditor />,
  //   },
  // ]);
  // keycloak.loadUserProfile()
  //const {getDefaultReqConfig} = useEventTrace();
  const dispatch = useDispatch();
  const [isAppUpdatePopupShow, setIsAppUpdatePopupShow] = useState(false);
  const applicationId = useSelector(state => state?.commonData?.applicationId);
  const token = keycloak.token;
  const authFlowType = useSelector(state => state?.commonData?.tenant?.authFlowType);
  // const gtag = initGA();

  //const token = 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJFOFVvX2V3cTE0MzlEQXRjWmpDTDJGU0RJR2lSQ20wWUJpT0F6ZVlPeExJIn0.eyJleHAiOjE2ODM2MTQwNjMsImlhdCI6MTY4MzYxMjg2MywiYXV0aF90aW1lIjoxNjgzNjEyODMyLCJqdGkiOiJlMTYzYjkxZS1lZjVlLTRmZDgtYTMyMC1jN2M3OGRkZTY3MDIiLCJpc3MiOiJodHRwOi8vc3R1ZGlvLmthbmRpLmRldi9yZWFsbXMvc3R1IiwiYXVkIjoiYWNjb3VudCIsInN1YiI6IjI3ZjI2ZDc0LTQ5YWEtNDA3NC1iN2EwLWIyOWViNGE2MzBkNCIsInR5cCI6IkJlYXJlciIsImF6cCI6InN0dS1mZS1jbGllbnQiLCJub25jZSI6Ijg3MzE4MTUzLTFlMTUtNGIyZC05MDAyLWYwZDI5NTFjNzM3NCIsInNlc3Npb25fc3RhdGUiOiI4MTExMTllMy02ZjA1LTQ4OTYtODM1OS02NjJlMzRjYmI3NjMiLCJhY3IiOiIwIiwiYWxsb3dlZC1vcmlnaW5zIjpbIiJdLCJyZWFsbV9hY2Nlc3MiOnsicm9sZXMiOlsiZGVmYXVsdC1yb2xlcy1zdHUiLCJvZmZsaW5lX2FjY2VzcyIsInVtYV9hdXRob3JpemF0aW9uIl19LCJyZXNvdXJjZV9hY2Nlc3MiOnsiYWNjb3VudCI6eyJyb2xlcyI6WyJtYW5hZ2UtYWNjb3VudCIsIm1hbmFnZS1hY2NvdW50LWxpbmtzIiwidmlldy1wcm9maWxlIl19fSwic2NvcGUiOiJvcGVuaWQgcHJvZmlsZSBlbWFpbCIsInNpZCI6IjgxMTExOWUzLTZmMDUtNDg5Ni04MzU5LTY2MmUzNGNiYjc2MyIsImVtYWlsX3ZlcmlmaWVkIjpmYWxzZSwibmFtZSI6InIgZSIsInByZWZlcnJlZF91c2VybmFtZSI6InN0c0BvcGVud2VhdmVyLmNvbSIsImdpdmVuX25hbWUiOiJyIiwiZmFtaWx5X25hbWUiOiJlIiwiZW1haWwiOiJzdHNAb3BlbndlYXZlci5jb20ifQ.aqFgBGDpJXBQl_3ucmNN39D6CaXt_Jqd2u1gtoUcs-ULcWU7cV6NLR9NFFD1nT4_2Hn5hHTTDdGFSqsCZ_qp3v8eZzvrrneOzjI_uToW68K0FupkFlX06fEmFfJFeM3GtDbmL0ELFMBmbNhyN2t1un6QRPV7KYqmh4VvriEaOzF2v0iBm4HZFGgnnoyj7lvT6F4fUhM107xj1NSM8zLnWSx7q-dWHdc-dd_YX5tREFCPRaIhoRN2f7tPaird5nt4B0N2L5G6sNh9p1eCp2ZXEnyEs_LeNJjtUae2oxfZa8rOE0GnP2tWEp0ngaS5ukjNpHMPrDAXFctG_8dDWLpa2A';
  dispatch(setAuthToken({token}));
  // const search = window.location.search;
  //  console.log('keycloak.idToken', keycloak.idToken)
  const params = props.params;
  const decoded = jwt_decode(token);
  const id = decoded.sub;
  // const navigate = useNavigate();
  // console.log('decoded', decoded)
  const [res, error, loading, axiosFetch] = useAxiosFunction({
    isDispatch: false,
  });
  const userProfile = {
    userId: decoded.sub,
    name: decoded.name,
    fullname: decoded.given_name,
    sessionId: decoded.sid,
    refererPage: params.get('referer-page'),
    ctaId: params.get('cta_id'),
    utmId: params.get('utm_id'),
    utmCampaign: params.get('utm_campaign'),
    utmMedium: params.get('utm_medium'),
    utmSource: params.get('utm_source'),
    utmContent: params.get('utm_content'),
    utmTerm: params.get('utm_term'),
    market: params.get('market'),
    plan: params.get('plan'),
    billing: params.get('billing')
  };
  useEffect(() => {
    dispatch(setCommonDataModelData({ userProfile: userProfile }));
  });
  const [isShowSelectedWorkspace, setIsShowSelectedWorkspace] = useState(true);
  const [isFeedbackPopupShow, setIsFeedbackPopupShow] = useState(false);
  const [isFeedbackPopupSource, setIsFeedbackPopupSource] = useState('autoPopup');
  const [isFeedbackCapturedAt, setIsFeedbackCapturedAt] = useState('autoPopup');
  const toggleFeedbackModal = () => {
    setIsFeedbackPopupShow(!isFeedbackPopupShow);
  };
  const [isOfferPopupShow, setIsOfferPopupShow] = useState(false);
  const [showCount, setShowCount] = useState(0);

  const showOfferCount = useSelector(state => state?.workSpace?.showOfferCount)
  useEffect(() => {
   const timeout = setTimeout(() => {
        if (showCount < 2 && (showOfferCount === undefined || !showOfferCount|| showOfferCount<2)) {
        setIsOfferPopupShow(true);
        dispatch(setWorkspaceData({ showOfferCount: (showOfferCount?showOfferCount:0) + 1 }));
        setShowCount(showCount+1)
      } else {
        setIsOfferPopupShow(false);
      }
      },  3 * 60 * 1000);
    return () => clearInterval(timeout);
  }, [showCount]);
  useEffect(() => {
    const timeout = setTimeout(() => {
      toggleFeedbackModal()
      setIsFeedbackPopupSource('autoPopup')
      setIsFeedbackCapturedAt('autoPopup')
    }, 3 * 60 * 1000);

    return () => clearTimeout(timeout);
  }, []);
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     toggleFeedbackModal();
  //     setIsFeedbackPopupSource('autoPopup');
  //     setIsFeedbackCapturedAt('autoPopup')
  //   }, 10000);

  //   return () => {

  //     clearInterval(interval);
  //   };
  // }, []);
  const [response, setResponse] = useState('');
  useEffect(() => {
    const newHeaders = {
      // updated headers
      Authorization: `Bearer ${keycloak.token}`,
      // any other headers you want to update
    };

    // Update the headers in the axios instance
    axiosInstance.defaults.headers = {
      ...axiosInstance.defaults.headers, // Keep existing headers
      ...newHeaders, // Add new headers
    };
    if (store.getState().commonData?.tenant?.tenantId === undefined)
      // axiosInstance["get"](`${apiBackendBaseUrl}iam/tenant/login`);
      axiosFetch({
        axiosInstance: axios,
        method: 'GET',
        url: `${apiBackendBaseUrl}iam/tenant/login`,
      });
    // axios({
    //   method: 'POST',
    //   url:
    //   `${apiBackendBaseUrl}${keyClockEndPoint}`,
    //   data: { userId: id, mailId:decoded?.email },
    //   headers: {   'Access-Control-Allow-Origin': '*',
    //   'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    //   'Content-Type': 'application/json','Authorization':`Bearer ${keycloak.token}`},

    // })

    axiosFetch({
      axiosInstance: axios,
      method: 'POST',
      url: `${apiBackendBaseUrl}${keyClockEndPoint}`,
      requestConfig: {
        userId: id,
        mailId: decoded?.email,
        refererPage: params.get('referer-page'),
        ctaId: params.get('cta_id'),
        utmId: params.get('utm_id'),
        utmCampaign: params.get('utm_campaign'),
        utmMedium: params.get('utm_medium'),
        utmSource: params.get('utm_source'),
        utmContent: params.get('utm_content'),
        utmTerm: params.get('utm_term'),
        market: params.get('market'),
        plan: params.get('plan'),
        billing: params.get('billing')
      },
    }).then(res => {
      // TagManager.dataLayer({
      //   dataLayer:{
      //     event: 'pageview',
      //   },
      // });
      // console.log('res :>> ', res);
      // debugger
      // if(res?.profileQuestionsRequired!==null && res?.profileQuestionsRequired!==undefined&&res?.profileQuestionsRequired){
      //   navigate("/signup/userprofile", { replace: true})
      // }
      // else{
      //   // navigate("/signup/userprofile", { replace: true})
      //   navigate("/workspace")
      // }
      if (res?.authFlowType === 'REGISTER') {
        pageview('sign_up page', 'sign_up');
        pageEventName('sign_up');
        // TagManager.dataLayer({
        //   dataLayer:{
        //     event: 'sign_up',
        //   },
        // });
      } else if (res?.authFlowType === 'LOGIN') {
        pageview('login page', 'login');
        pageEventName('login');
        // TagManager.dataLayer({
        //   dataLayer:{
        //     event: 'login',
        //   },
        // });
      }
      if (res?.tenantName === 'email') {
        keycloak.login();
        res = undefined;
      }
      setResponse(res);
      // console.log("response,idToken",response,keycloak.idToken)
      dispatch(setCommonDataModelData({ tenant: res }));

      // const updatedHeaders = { ...requestHeaders }; // Update a specific header value
      // updatedHeaders['Authorization'] =`Bearer ${store.getState().commonData?.authToken?.token}`;
      // dispatch(setCommonDataModelData({ userProfile: userProfile }));
      keycloak
        .updateToken(-1)
        .then(function (refreshed) {
          if (refreshed) {
            dispatch(setAuthToken({token: keycloak.token}));
            const newHeaders = {
              Authorization: `Bearer ${store.getState()?.authToken?.token}`, // any other headers you want to update
            };
            axiosInstance.defaults.headers = {
              ...axiosInstance.defaults.headers, // Keep existing headers
              ...newHeaders, // Add new headers
            };
          } else {
            // console.log('Token is still valid');
          }
        })
        .catch(function () {
          // console.log('Failed to refresh the token, or the session has expired');
          keycloak.login();
        });
    });
  }, []);

  // const [response, error, loading] = useAxiosFetch({
  //   endPoint: `${apiBackendBaseUrl}${keyClockEndPoint}`,
  //   method: 'POST',
  //   requestConfig: { userId: id, mailId:decoded?.email },
  // });
  // if (!loading && !error && response) {
  //   dispatch(setCommonDataModelData({ tenant: response }));
  //   dispatch(setCommonDataModelData({ userProfile: userProfile }));
  // }
  // useEffect(() => {
  //   console.log("expired " + new Date());
  //   keycloak
  //     .updateToken(50);
  // }, [keycloak.isTokenExpired()]);

  // keycloak.updateToken(100);
  const lookUpData = async function () {
    // const defaultReqConfig = getDefaultReqConfig();
    //axiosInstance.defaults.headers.common['X-Data-Token']=defaultReqConfig
    const response = await axiosInstance['get'](
      `${apiBackendBaseUrl}pagedesigner/application/getappversionnumber`,
    );
    const newAppVersion = response?.data;
    const prevAppVersion = localStorage.getItem('appVersion');
    const isAppUpdated =
      prevAppVersion && newAppVersion && Number(prevAppVersion) !== newAppVersion;
    if (isAppUpdated) {
      setIsAppUpdatePopupShow(true);
      localStorage.setItem('isAppUpdatePopupShow', 'true');
      // window?.location?.reload();
    }
    if ((!prevAppVersion && newAppVersion) || Number(prevAppVersion) !== newAppVersion) {
      localStorage.setItem('appVersion', newAppVersion);
    }
  };

  const localStorageAppVersionHandler = event => {
    if (event?.key === 'app-refresh-trigger' && event?.newValue === 'true') {
      localStorage.setItem('app-refresh-trigger', 'false');
      unloadAppversionPopup();
    }

    if (event.key === 'isAppUpdatePopupShow' && event.newValue === 'true') {
      setIsAppUpdatePopupShow(true);
    }
  };

  function unloadAppversionPopup() {
    setIsAppUpdatePopupShow(false);
    localStorage.setItem('isAppUpdatePopupShow', 'false');
    window?.location?.reload();
  }
  useEffect(() => {
    //    console.log("testingUrl==>",testingUrl,"envValue==>",process.env.REACT_APP_TESTING_URL,"testUrl==>",testUrl,"envFile1",process.env.REACT_APP_TEST_URL)
    dispatch(updateZoomPercentage(100));
    const fnRefreshToken = () => {
      keycloak
        .updateToken(-1)
        .then(function (refreshed) {
          if (refreshed) {
            // console.log('refreshToken',keycloak.idToken)
            dispatch(setAuthToken({token: keycloak.token}));
            const newHeaders = {
              // updated headers
              Authorization: `Bearer ${store.getState()?.authToken?.token}`, // any other headers you want to update
            };

            // Update the headers in the axios instance
            axiosInstance.defaults.headers = {
              ...axiosInstance.defaults.headers, // Keep existing headers
              ...newHeaders, // Add new headers
            };
            // console.log('Token was successfully refreshed');
          } else {
            // console.log('Token is still valid');
          }
        })
        .catch(function () {
          // console.log('Failed to refresh the token, or the session has expired');
          keycloak.login();
        });
    };
    const timer = setInterval(() => {
      fnRefreshToken();
    }, 30000);

    const appVersionUpdateIntervalTime = 15 * 60 * 1000;
    const appVersionUpdateCheck = setInterval(() => {
      lookUpData();
    }, appVersionUpdateIntervalTime);
    // if (window.opener === null) {
    //   const id = uuid();
    //   sessionStorage.setItem('uniqueId', id);
    // }
    window.addEventListener('storage', localStorageAppVersionHandler)

    return () => {
      clearInterval(timer);
      clearInterval(appVersionUpdateCheck);
      window.removeEventListener('storage', localStorageAppVersionHandler);
    };
  }, []);
  return (
    <PopoverProvider>
    <div className="App">
      {isAppUpdatePopupShow && (
        <NewUpdatePopup
          setIsAppUpdatePopupShow={setIsAppUpdatePopupShow}
          unloadAppversionPopup={unloadAppversionPopup}
        />
      )}
      <React.Suspense>
        <BrowserRouter>
          <Routes>
          {/* <Route
              path="/"
              // element={<Home />}
              element={res?.profileQuestionsRequired!==null && res?.profileQuestionsRequired!==undefined&&res?.profileQuestionsRequired && <Navigate replace to="/signup/userprofile" />}
            /> */}
          {/* <Route
              path="/"
              // element={<Home />}
              element={res?.profileQuestionsRequired!==null && res?.profileQuestionsRequired!==undefined&&res?.profileQuestionsRequired && <Navigate replace to="/signup/userprofile" />}
            /> */}
            <Route
              path="/"
              // element={<Home />}
              element={(response?.profileQuestionsRequired && <Navigate replace to={`/workspace/userprofile${props?.query}`} />) || (response?.tenantId !== undefined && <Navigate replace to="/workspace" />)}
            />


<Route path="/payments/makepayment" element={<><LoggerModalParent><Header openFeedbackModal={toggleFeedbackModal} setIsFeedbackPopupSource={setIsFeedbackPopupSource} setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} setIsFeedbackPopupShow ={setIsFeedbackPopupShow}/><MakePayment isShowSelectedWorkspace={isShowSelectedWorkspace} isFeedbackPopupShow={isFeedbackPopupShow} setIsFeedbackPopupShow={setIsFeedbackPopupShow} toggleFeedbackModal={toggleFeedbackModal} setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} isFeedbackCapturedAt={isFeedbackCapturedAt} setIsFeedbackPopupSource={setIsFeedbackPopupSource} isFeedbackPopupSource={isFeedbackPopupSource}/></LoggerModalParent></>} />
           <Route
              path="/signup"
              // element={<Home />}
              element={(response?.profileQuestionsRequired && <Navigate replace to={`/workspace/userprofile${props?.query}`} />) || (response?.tenantId !== undefined && <Navigate replace to={`/workspace${props?.query}`} />)}
            />
            <Route path="/workspace" element={(response?.profileQuestionsRequired && <Navigate replace to={`/workspace/userprofile${props?.query}`} />) || (response?.tenantId !== undefined && <LoggerModalParent><WorkSpace isShowSelectedWorkspace={isShowSelectedWorkspace} isFeedbackPopupShow={isFeedbackPopupShow} setIsFeedbackPopupShow={setIsFeedbackPopupShow} toggleFeedbackModal={toggleFeedbackModal} setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} isFeedbackCapturedAt={isFeedbackCapturedAt} setIsFeedbackPopupSource={setIsFeedbackPopupSource} isFeedbackPopupSource={isFeedbackPopupSource} isOfferPopupShow={isOfferPopupShow} setIsOfferPopupShow={setIsOfferPopupShow}/></LoggerModalParent>)} />
            <Route path="/app-templates" element={<><LoggerModalParent><Header openFeedbackModal={toggleFeedbackModal} setIsFeedbackPopupSource={setIsFeedbackPopupSource} setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} setIsFeedbackPopupShow ={setIsFeedbackPopupShow}/><AppTemplates isShowSelectedWorkspace={isShowSelectedWorkspace} isFeedbackPopupShow={isFeedbackPopupShow} setIsFeedbackPopupShow={setIsFeedbackPopupShow} toggleFeedbackModal={toggleFeedbackModal} setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} isFeedbackCapturedAt={isFeedbackCapturedAt} setIsFeedbackPopupSource={setIsFeedbackPopupSource} isFeedbackPopupSource={isFeedbackPopupSource}/></LoggerModalParent></>} />
            <Route path="/generate-app" element={<><LoggerModalParent><Header openFeedbackModal={toggleFeedbackModal} setIsFeedbackPopupSource={setIsFeedbackPopupSource} setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} setIsFeedbackPopupShow ={setIsFeedbackPopupShow}/><GenerateApps/></LoggerModalParent></>} />
            <Route
              path="/docs/userguide"
              element={response?.tenantId !== undefined && <HelpDoc />}

            />
            <Route element={<LoggerModalParent><LayoutWithHeader setIsShowSelectedWorkspace={setIsShowSelectedWorkspace} isFeedbackPopupShow={isFeedbackPopupShow} setIsFeedbackPopupShow={setIsFeedbackPopupShow} toggleFeedbackModal={toggleFeedbackModal} setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} isFeedbackCapturedAt={isFeedbackCapturedAt} setIsFeedbackPopupSource={setIsFeedbackPopupSource} isFeedbackPopupSource={isFeedbackPopupSource} isOfferPopupShow={isOfferPopupShow} setIsOfferPopupShow={setIsOfferPopupShow}/></LoggerModalParent>}>
              <Route
                path="/page-editor"
                element={applicationId ?<LoggerModalParent> <PageEditor isFeedbackPopupShow={isFeedbackPopupShow} setIsFeedbackPopupShow={setIsFeedbackPopupShow} toggleFeedbackModal={toggleFeedbackModal} setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} isFeedbackCapturedAt={isFeedbackCapturedAt} setIsFeedbackPopupSource={setIsFeedbackPopupSource} isFeedbackPopupSource={isFeedbackPopupSource} isOfferPopupShow={isOfferPopupShow} setIsOfferPopupShow={setIsOfferPopupShow}/></LoggerModalParent> : <Navigate replace to="/workspace" />}
              />
              <Route
                path="/flow-editor"
                element={applicationId ?<LoggerModalParent>  <FlowEditor isFeedbackPopupShow={isFeedbackPopupShow} setIsFeedbackPopupShow={setIsFeedbackPopupShow} toggleFeedbackModal={toggleFeedbackModal} setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} isFeedbackCapturedAt={isFeedbackCapturedAt} setIsFeedbackPopupSource={setIsFeedbackPopupSource} isFeedbackPopupSource={isFeedbackPopupSource} isOfferPopupShow={isOfferPopupShow} setIsOfferPopupShow={setIsOfferPopupShow}/></LoggerModalParent>  : <Navigate replace to="/workspace" />}
              />
              <Route
                path="/resource-editor"
                element={applicationId ? <LoggerModalParent> <ResourceEditor isFeedbackPopupShow={isFeedbackPopupShow} setIsFeedbackPopupShow={setIsFeedbackPopupShow} toggleFeedbackModal={toggleFeedbackModal} setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} isFeedbackCapturedAt={isFeedbackCapturedAt} setIsFeedbackPopupSource={setIsFeedbackPopupSource} isFeedbackPopupSource={isFeedbackPopupSource} isOfferPopupShow={isOfferPopupShow} setIsOfferPopupShow={setIsOfferPopupShow}/> </LoggerModalParent> : <Navigate replace to="/workspace" />}
              />
              <Route path="/page-templates" element={<LoggerModalParent><PageTemplates /></LoggerModalParent>} />

              <Route path="/page-detail" element={<LoggerModalParent><PreviwDetail /></LoggerModalParent>} />
              <Route path="/page-editor/responsive-view" element={<LoggerModalParent><ResponsiveViewPageEditor /></LoggerModalParent>} />
              <Route
                path="/page-editor/responsive-view/desktop"
                element={<LoggerModalParent><ResponsiveViewPageEditor /></LoggerModalParent>}
              />
              <Route
                path="/page-editor/responsive-view/tab"
                element={<LoggerModalParent><ResponsiveViewPageEditor /></LoggerModalParent>}
              />
              <Route
                path="/page-editor/responsive-view/mobile"
                element={<LoggerModalParent><ResponsiveViewPageEditor /></LoggerModalParent>}
              />
              <Route
                path="/page-editor/responsive-view/small-mobile"
                element={<LoggerModalParent><ResponsiveViewPageEditor /></LoggerModalParent>}
              />
              <Route path="/pagetemplate-listing" element={<LoggerModalParent><PageTemplateListing /></LoggerModalParent>} />
              <Route path="/pagetemplate-listing/section-template" element={<LoggerModalParent><SectionTemplate /></LoggerModalParent>} />
              <Route path="/pagetemplate-listing/page-template" element={<LoggerModalParent><PageTemplate /></LoggerModalParent>} />
              <Route path="/pagetemplate-listing/app-template" element={<LoggerModalParent><AppTemplate /></LoggerModalParent>} />
              <Route path="/package-listing" element={<LoggerModalParent><PackageMain isFeedbackPopupShow={isFeedbackPopupShow} setIsFeedbackPopupShow={setIsFeedbackPopupShow} toggleFeedbackModal={toggleFeedbackModal} setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} isFeedbackCapturedAt={isFeedbackCapturedAt} setIsFeedbackPopupSource={setIsFeedbackPopupSource} isFeedbackPopupSource={isFeedbackPopupSource} isOfferPopupShow={isOfferPopupShow} setIsOfferPopupShow={setIsOfferPopupShow}/></LoggerModalParent>} />
              <Route path="/package-listing/packages" element={<LoggerModalParent><PackageListing isFeedbackPopupShow={isFeedbackPopupShow} setIsFeedbackPopupShow={setIsFeedbackPopupShow} toggleFeedbackModal={toggleFeedbackModal} setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} isFeedbackCapturedAt={isFeedbackCapturedAt} setIsFeedbackPopupSource={setIsFeedbackPopupSource} isFeedbackPopupSource={isFeedbackPopupSource} isOfferPopupShow={isOfferPopupShow} setIsOfferPopupShow={setIsOfferPopupShow}/></LoggerModalParent>} />
              {/* <Route path="/resource-editor/callback" element={<AuthorizationCode />} /> */}
              <Route path="/resource-editor/callback" element={<LoggerModalParent><Callback /></LoggerModalParent>} />
            </Route>
            <Route
              path="/workspace/userprofile"
              element={(!response?.profileQuestionsRequired && <Navigate replace to={`/workspace${props?.query}`} />) || (<LoggerModalParent><UserProfile /></LoggerModalParent>)}
            />
             <Route
                path="/account"
                element={
                <LoggerModalParent> <Header zIndex="999" openFeedbackModal={toggleFeedbackModal} setIsFeedbackPopupSource={setIsFeedbackPopupSource} setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} setIsFeedbackPopupShow ={setIsFeedbackPopupShow} isOfferPopupShow={isOfferPopupShow} setIsOfferPopupShow={setIsOfferPopupShow}/> <AccountTabComponent  isShowSelectedWorkspace={isShowSelectedWorkspace} isFeedbackPopupShow={isFeedbackPopupShow} setIsFeedbackPopupShow={setIsFeedbackPopupShow} toggleFeedbackModal={toggleFeedbackModal} setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} isFeedbackCapturedAt={isFeedbackCapturedAt} setIsFeedbackPopupSource={setIsFeedbackPopupSource} isFeedbackPopupSource={isFeedbackPopupSource} isOfferPopupShow={isOfferPopupShow} setIsOfferPopupShow={setIsOfferPopupShow}/> </LoggerModalParent>}
              />
              <Route
                path="/payments/paymentlink"
                element={
                <LoggerModalParent> 
                  <Header zIndex="999" 
                    openFeedbackModal={toggleFeedbackModal} 
                    setIsFeedbackPopupSource={setIsFeedbackPopupSource} 
                    setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} 
                    setIsFeedbackPopupShow ={setIsFeedbackPopupShow}/> 
                  <PaymentLink
                  isFeedbackPopupShow={isFeedbackPopupShow}
                  setIsFeedbackPopupSource={setIsFeedbackPopupSource} 
                  setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} 
                  setIsFeedbackPopupShow ={setIsFeedbackPopupShow}
                  isFeedbackCapturedAt={isFeedbackCapturedAt} 
                  isFeedbackPopupSource={isFeedbackPopupSource}
                  />
                </LoggerModalParent>}
              />
               <Route
                path="/payments/generateinvoice"
                element={
                <LoggerModalParent> 
                  <Header zIndex="999" 
                    openFeedbackModal={toggleFeedbackModal} 
                    setIsFeedbackPopupSource={setIsFeedbackPopupSource} 
                    setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} 
                    setIsFeedbackPopupShow ={setIsFeedbackPopupShow}/> 
                  <GenerateInvoice
                  isFeedbackPopupShow={isFeedbackPopupShow}
                  setIsFeedbackPopupSource={setIsFeedbackPopupSource} 
                  setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} 
                  setIsFeedbackPopupShow ={setIsFeedbackPopupShow}
                  isFeedbackCapturedAt={isFeedbackCapturedAt} 
                  isFeedbackPopupSource={isFeedbackPopupSource}
                  />
                </LoggerModalParent>}
              />
               <Route
                path="/payments/downloadinvoice"
                element={
                <LoggerModalParent> 
                  <Header zIndex="999" 
                    openFeedbackModal={toggleFeedbackModal} 
                    setIsFeedbackPopupSource={setIsFeedbackPopupSource} 
                    setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} 
                    setIsFeedbackPopupShow ={setIsFeedbackPopupShow}/> 
                  <Invoice
                  isFeedbackPopupShow={isFeedbackPopupShow}
                  setIsFeedbackPopupSource={setIsFeedbackPopupSource} 
                  setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} 
                  setIsFeedbackPopupShow ={setIsFeedbackPopupShow}
                  isFeedbackCapturedAt={isFeedbackCapturedAt} 
                  isFeedbackPopupSource={isFeedbackPopupSource}
                  />
                </LoggerModalParent>}
              />
               <Route
                path="/subscriptions/managesubscription"
                element={
                <LoggerModalParent> 
                  <Header zIndex="999" 
                    openFeedbackModal={toggleFeedbackModal} 
                    setIsFeedbackPopupSource={setIsFeedbackPopupSource} 
                    setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} 
                    setIsFeedbackPopupShow ={setIsFeedbackPopupShow}
                    isOfferPopupShow={isOfferPopupShow}
                    setIsOfferPopupShow={setIsOfferPopupShow}
                    /> 
                  <CancelSubscription
                  isFeedbackPopupShow={isFeedbackPopupShow}
                  setIsFeedbackPopupSource={setIsFeedbackPopupSource} 
                  setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} 
                  setIsFeedbackPopupShow ={setIsFeedbackPopupShow}
                  isFeedbackCapturedAt={isFeedbackCapturedAt} 
                  isFeedbackPopupSource={isFeedbackPopupSource}
                  />
                </LoggerModalParent>}
              />
               <Route
                path="/executionlog"
                element={
                 <LoggerModalParent>
                   <Header zIndex="999"
                    openFeedbackModal={toggleFeedbackModal} 
                    setIsFeedbackPopupSource={setIsFeedbackPopupSource} 
                    setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} 
                    setIsFeedbackPopupShow ={setIsFeedbackPopupShow} 
                    isOfferPopupShow={isOfferPopupShow} 
                    setIsOfferPopupShow={setIsOfferPopupShow}/> 
                    <FlowExecutionTab  
                    isFeedbackPopupShow={isFeedbackPopupShow}
                    setIsFeedbackPopupSource={setIsFeedbackPopupSource} 
                    setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} 
                    setIsFeedbackPopupShow ={setIsFeedbackPopupShow}
                    isFeedbackCapturedAt={isFeedbackCapturedAt} 
                    isFeedbackPopupSource={isFeedbackPopupSource}
                   /> 
                    </LoggerModalParent>}
              />
            <Route path="/generate-template" element={<><LoggerModalParent><Header openFeedbackModal={toggleFeedbackModal} setIsFeedbackPopupSource={setIsFeedbackPopupSource} setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} setIsFeedbackPopupShow ={setIsFeedbackPopupShow}/><GenAiTemplate/></LoggerModalParent></>} />
            {hasSalesRole && <Route path="/generate-aiapp" element={<><LoggerModalParent><Header openFeedbackModal={toggleFeedbackModal} setIsFeedbackPopupSource={setIsFeedbackPopupSource} setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} setIsFeedbackPopupShow ={setIsFeedbackPopupShow}/><GenerateApp/></LoggerModalParent></>} />}            
            <Route path="/website-build" element={<><LoggerModalParent><WebsiteGen/></LoggerModalParent></>} />
            <Route path="/website-build/:pagename/:draftid" element={<><LoggerModalParent><WebsiteGen/></LoggerModalParent></>} />
            <Route
                path="/admin"
                element={
                  <>
                    <Header zIndex="999" openFeedbackModal={toggleFeedbackModal} setIsFeedbackPopupSource={setIsFeedbackPopupSource} setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} setIsFeedbackPopupShow={setIsFeedbackPopupShow} isOfferPopupShow={isOfferPopupShow} 
                    setIsOfferPopupShow={setIsOfferPopupShow} />
                    {(hasAdminUiRole() || hasAdminUiAdminRole()) ? (
                      <LoggerModalParent>
                        <AdminDashboard isShowSelectedWorkspace={isShowSelectedWorkspace} isFeedbackPopupShow={isFeedbackPopupShow} setIsFeedbackPopupShow={setIsFeedbackPopupShow} toggleFeedbackModal={toggleFeedbackModal} setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} isFeedbackCapturedAt={isFeedbackCapturedAt} setIsFeedbackPopupSource={setIsFeedbackPopupSource} isFeedbackPopupSource={isFeedbackPopupSource} isOfferPopupShow={isOfferPopupShow} setIsOfferPopupShow={setIsOfferPopupShow}/>
                      </LoggerModalParent>
                    ) : (
                      <div style={{ textAlign: 'center', padding: '50px' }}>
                        <h1>Unauthorized</h1>
                        <p>You do not have permission to view this page.</p>
                      </div>
                    )}
                  </>
                }
              >
            <Route path="usersignup" element={(hasAdminUserCreateRole() || hasAdminUiAdminRole())?(<><LoggerModalParent><SignupNewUser/></LoggerModalParent></>):(<div style={{ textAlign: 'center', padding: '50px' }}>
                <h1>Unauthorized</h1>
                <p>You do not have permission to view this page.</p>
              </div>)} />
            <Route path="delete-user" element={(hasAdminUserDeleteRole() || hasAdminUiAdminRole())?(<><LoggerModalParent><DeleteUser/></LoggerModalParent></>):(<div style={{ textAlign: 'center', padding: '50px' }}>
                <h1>Unauthorized</h1>
                <p>You do not have permission to view this page.</p>
              </div>)} />
              <Route path="search" element={<><LoggerModalParent><Search/></LoggerModalParent></>} />
              <Route path="multipledeployment" element={(hasAdminRoleMultipleDeployment() || hasAdminUiAdminRole())?(<><LoggerModalParent><MultipleDeployment/></LoggerModalParent></>):(<div style={{ textAlign: 'center', padding: '50px' }}>
                <h1>Unauthorized</h1>
                <p>You do not have permission to view this page.</p>
              </div>)} />
              <Route path="moveapps" element={(hasAdminRoleMoveApps() || hasAdminUiAdminRole())?(<><LoggerModalParent><MoveApps/></LoggerModalParent></>):(<div style={{ textAlign: 'center', padding: '50px' }}>
                <h1>Unauthorized</h1>
                <p>You do not have permission to view this page.</p>
              </div>)} />
              <Route path="promotions" element={(<><LoggerModalParent><ReferralCode/></LoggerModalParent></>)} />
              {/* <Route path="view-timeline" element={hasAdminUiViewTimelineRole()?(<><LoggerModalParent><ViewTimeline/></LoggerModalParent></>):(<div style={{ textAlign: 'center', padding: '50px' }}>
                <h1>Unauthorized</h1>
                <p>You do not have permission to view this page.</p>
              </div>)} /> */}
              <Route path="add-charge" element={(hasAdminUiAddChargeRole() || hasAdminUiAdminRole())?(<><LoggerModalParent><AddCharge/></LoggerModalParent></>):(<div style={{ textAlign: 'center', padding: '50px' }}>
                <h1>Unauthorized</h1>
                <p>You do not have permission to view this page.</p>
              </div>)} />
              <Route path="apply-discount" element={hasAdminUiApplyDiscountRole()?(<><LoggerModalParent><ApplyDiscount/></LoggerModalParent></>):(<div style={{ textAlign: 'center', padding: '50px' }}>
                <h1>Unauthorized</h1>
                <p>You do not have permission to view this page.</p>
              </div>)} />
              <Route path="sync-payment" element={(hasAdminUiSyncPaymentRole() || hasAdminUiAdminRole())?(<><LoggerModalParent><SyncPayment/></LoggerModalParent></>):(<div style={{ textAlign: 'center', padding: '50px' }}>
                <h1>Unauthorized</h1>
                <p>You do not have permission to view this page.</p>
              </div>)} />
              <Route path="adminuiroles" element={( hasAdminUiAdminRole())?(<><LoggerModalParent><AdminUiRoles/></LoggerModalParent></>):(<div style={{ textAlign: 'center', padding: '50px' }}>
                <h1>Unauthorized</h1>
                <p>You do not have permission to view this page.</p>
              </div>)} />
              <Route path="generate-payment-link" element={( hasAdminUiPaymentLinkGenerationRole() || hasAdminUiAdminRole())?(<><LoggerModalParent><Paymentlink/></LoggerModalParent></>):(<div style={{ textAlign: 'center', padding: '50px' }}>
                <h1>Unauthorized</h1>
                <p>You do not have permission to view this page.</p>
              </div>)} />
              <Route path="domainmanagement" element={(hasAdminUiDomainReadManagementRole() || hasAdminUiDomainWriteManagementRole())?(<><LoggerModalParent><SearchDomain/></LoggerModalParent></>):(<div style={{ textAlign: 'center', padding: '50px' }}>
                <h1>Unauthorized</h1>
                <p>You do not have permission to view this page.</p>
              </div>)} />
            </Route>
          </Routes>
        </BrowserRouter>
      </React.Suspense>
    </div>
    </PopoverProvider>
  );
}

export default App;

export const AppHome = () => {
  const dispatch = useDispatch();
  const keycloakLogin=()=>{
    // let uniqueId = localStorage.getItem('uniqueId')
    // if(uniqueId){
    //   localStorage.removeItem('uniqueId')
    // }
     dispatch(resetWorkspace());
     dispatch(resetResourceEditor());
     dispatch(resetPageEditor());
     dispatch(resetPageEditorCanvas());
     dispatch(resetPageEditorModelData());
     dispatch(resetCommonData());
     dispatch(resetAuthToken());
     dispatch(clearFlowEditor());
     if (window.location.href.includes("payments/makepayment") || window.location.href.includes("website-build")) {
     }
     else{
      keycloak.login();
     }
}
const [isShowSelectedWorkspace, setIsShowSelectedWorkspace] = useState(true);
const [isFeedbackPopupShow, setIsFeedbackPopupShow] = useState(false);
const [isFeedbackPopupSource, setIsFeedbackPopupSource] = useState('autoPopup');
const [isFeedbackCapturedAt, setIsFeedbackCapturedAt] = useState('autoPopup');
const toggleFeedbackModal = () => {
  setIsFeedbackPopupShow(!isFeedbackPopupShow);
};
  return (
    <div>
      <React.Suspense>
        <BrowserRouter>
          <Routes>
            {/* <Route
              path="/*"
              // element={<Home />}
              element={ <Navigate replace to="/" />}
            /> */}
         
            <Route path="/signup" element={<Signup />} />
<Route path="/payments/makepayment" element={<><LoggerModalParent><Header openFeedbackModal={toggleFeedbackModal} setIsFeedbackPopupSource={setIsFeedbackPopupSource} setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} setIsFeedbackPopupShow ={setIsFeedbackPopupShow}/><MakePayment isShowSelectedWorkspace={isShowSelectedWorkspace} isFeedbackPopupShow={isFeedbackPopupShow} setIsFeedbackPopupShow={setIsFeedbackPopupShow} toggleFeedbackModal={toggleFeedbackModal} setIsFeedbackCapturedAt={setIsFeedbackCapturedAt} isFeedbackCapturedAt={isFeedbackCapturedAt} setIsFeedbackPopupSource={setIsFeedbackPopupSource} isFeedbackPopupSource={isFeedbackPopupSource}/></LoggerModalParent></>} />
<Route path="/website-build" element={<><LoggerModalParent><WebsiteGen/></LoggerModalParent></>} />
            <Route path="/website-build/:pagename/:draftid" element={<><LoggerModalParent><WebsiteGen/></LoggerModalParent></>} />

                        {/* <Route
              path="/*"
              // element={<Home />}
              element={ keycloak.login()}
            /> */}
            <Route component={keycloakLogin()} />
          </Routes>
        </BrowserRouter>
      </React.Suspense>
    </div>
  );
};
